"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LockReasonsMetadata = exports.BalanceEventType = exports.ADJUSTMENT_REQUEST_GROUP_NAME = exports.AdjustmentType = exports.CloseMonthPossibleErrors = void 0;
var CloseMonthPossibleErrors;
(function (CloseMonthPossibleErrors) {
    CloseMonthPossibleErrors["ERR_CLOSURE_001_INVALID_COMMISSION"] = "ERR_CLOSURE_001_INVALID_COMMISSION";
    CloseMonthPossibleErrors["ERR_CLOSURE_002_INVALID_CREDITOR"] = "ERR_CLOSURE_002_INVALID_CREDITOR";
})(CloseMonthPossibleErrors = exports.CloseMonthPossibleErrors || (exports.CloseMonthPossibleErrors = {}));
var AdjustmentType;
(function (AdjustmentType) {
    AdjustmentType["REQUEST"] = "request";
    AdjustmentType["REGULAR"] = "regular";
})(AdjustmentType = exports.AdjustmentType || (exports.AdjustmentType = {}));
exports.ADJUSTMENT_REQUEST_GROUP_NAME = 'Ajustes Solicitados';
var BalanceEventType;
(function (BalanceEventType) {
    BalanceEventType[BalanceEventType["UNSEEN"] = 0] = "UNSEEN";
    BalanceEventType[BalanceEventType["SEEN"] = 1] = "SEEN";
    BalanceEventType[BalanceEventType["AGREED"] = 2] = "AGREED";
    BalanceEventType[BalanceEventType["DISAGREED"] = 3] = "DISAGREED";
    BalanceEventType[BalanceEventType["ANSWER"] = 4] = "ANSWER";
    BalanceEventType[BalanceEventType["RESOLVED"] = 5] = "RESOLVED";
})(BalanceEventType = exports.BalanceEventType || (exports.BalanceEventType = {}));
var LockReasonsMetadata;
(function (LockReasonsMetadata) {
    LockReasonsMetadata["APPLY_RULES"] = "applying_rules";
    LockReasonsMetadata["CLOSURE_COMMISSIONS_BACKUP"] = "all_commissions_closure_backup";
})(LockReasonsMetadata = exports.LockReasonsMetadata || (exports.LockReasonsMetadata = {}));
